export default __webpack_public_path__ + "img/data-analytics.283aba3d.png";